import { isTruthy } from "@dashboard/library";
import { useParams } from "react-router-dom";

import { RouteParams } from "../../components/Transcription/Transcription.decl";

import { CALL_TYPE } from "@/constants/call.decl";
import { useCall } from "@/hooks/useCall/useCall";
import { useBaseStore } from "@/store/store";

export function useTranscriptionRule() {
  const { callType } = useParams<RouteParams>();

  const { call } = useCall();
  const audio = useBaseStore((store) => store.audio);
  const transcriptionSettings = useBaseStore(
    (store) => store.transcriptionSettings
  );

  const enabledMapper = {
    [CALL_TYPE.Recording]: transcriptionSettings?.calls?.isEnabled,
    [CALL_TYPE.Voicemail]: transcriptionSettings?.voicemails?.isEnabled,
  };

  const isLowConfidenceCall = call?.transcriptStatus === "lowConfidence";
  const isAvailableCall = call?.transcriptStatus === "available";

  const hasStatusWithTranscription = isAvailableCall || isLowConfidenceCall;

  return {
    isLowConfidenceCall,
    isAvailableCall,
    isTranscriptionAvailable: [
      hasStatusWithTranscription,
      (call?.transcription?.content?.utterances?.length ?? 0) > 0,
      audio?.url,
    ].every(isTruthy),
    isTranscriptionDisabled: !enabledMapper[callType!],
  };
}
